import React, { useEffect, useState } from "react";
import { Popconfirm } from "antd";

import useAllowChanges from "../../../hooks/useAllowChanges";
import Tag from "./tag";
import { CrossIcon } from "../../../../../resource/icons";

const House = ({ setFieldsValue, houseObj }) => {
	const [showCross, setShowCross] = useState();
	const [showConfirm, setShowConfirm] = useState();
	const changeable = useAllowChanges();
	useEffect(() => {
		if (changeable) {
			const listener = () => {
				setShowConfirm(false);
				setShowCross(false);
			};
			document
				.getElementsByClassName("NewVoting")[0]
				.addEventListener("scroll", listener);
			return () =>
				document
					.getElementsByClassName("NewVoting")[0]
					.removeEventListener("scroll", listener);
		}
	});
	return (
		<>
			<span
				key={houseObj.houseId}
				className="house"
				onMouseEnter={() => {
					setShowCross(houseObj);
				}}
				onMouseLeave={() => {
					setShowCross(false);
				}}
			>
				<Tag tagType={"tag-house"}>
					{houseObj.building}
					{houseObj.corpus && houseObj.corpus && ` к.${houseObj.corpus}`}
					{(showCross === houseObj || showConfirm) && changeable && (
						<Popconfirm
							placement="top"
							onVisibleChange={(value) => setShowConfirm(value)}
							title={"Удалить дом из опроса?"}
							onConfirm={() => {
								setFieldsValue({
									[`addresses[${houseObj.houseId}]`]: false,
								});
							}}
							okText="Да"
							cancelText="Нет"
						>
							<CrossIcon className="cross-icon" />
						</Popconfirm>
					)}
				</Tag>
			</span>
		</>
	);
};

export default House;
